<template>
    <div>
        <div class="main-cnt block-image ex-multi-img">
            <slider-voucher></slider-voucher>
        </div>
    </div>
</template>

<script>
/* global $ */
import Vue from 'vue';
// eslint-disable-next-line no-unused-vars
import Slick from 'vue-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default {
    name: 'SpImageMultiVoucher',
    data () {
        return {
        };
    },
    computed: {
    },
    created () {
    },
    methods: {
    },
};

Vue.component('slider-voucher', {
    template: `
        <div class="lst-multi-img">
            <div class="block-cnt-img">
                <img src=" ` + require('@/assets/img/voucher-img.png') + ` ">

                <div class="footer-img">
                    2019/12/13 15:00.jpg
                </div>
            </div>
            <div class="block-cnt-img">
                <img src=" ` + require('@/assets/img/bill_sample.png') + `">

                <div class="footer-img">
                    2019/12/13 15:00.jpg
                </div>
            </div>
        </div>

    `,
    props: ['slides'],
    data () {
        return {
            sliderOptions: {
                dots: true,
                arrows: false,
                mobileFirst: true,
                infinite: true,
                slidesToShow: 1,
            },
        };
    },
    methods: {
        initSlider () {
            $(this.$el).slick(this.sliderOptions);
        },
        destroySlider () {
            $(this.$el).slick('unslick');
        },
    },

    mounted () {
        this.initSlider();
    },
    watch: {
        slides () {
            this.destroySlider();
            Vue.nextTick(() => {
                this.initSlider();
            });
        },
    },
});
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/ImageMulti.vue